import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Automation\UpdateAutomationModelConfigController::__invoke
* @see app/Http/Controllers/Automation/UpdateAutomationModelConfigController.php
* @route '/api/automation/config-model'
*/
const UpdateAutomationModelConfigController = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAutomationModelConfigController.url(options),
    method: 'put',
})

UpdateAutomationModelConfigController.definition = {
    methods: ["put"],
    url: '/api/automation/config-model',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Automation\UpdateAutomationModelConfigController::__invoke
* @see app/Http/Controllers/Automation/UpdateAutomationModelConfigController.php
* @route '/api/automation/config-model'
*/
UpdateAutomationModelConfigController.url = (options?: RouteQueryOptions) => {
    return UpdateAutomationModelConfigController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Automation\UpdateAutomationModelConfigController::__invoke
* @see app/Http/Controllers/Automation/UpdateAutomationModelConfigController.php
* @route '/api/automation/config-model'
*/
UpdateAutomationModelConfigController.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAutomationModelConfigController.url(options),
    method: 'put',
})

export default UpdateAutomationModelConfigController